import { createRouterReducer } from '@lagunovsky/redux-react-router'

import browserHistory from '../utils/browserHistory'

export default createRouterReducer(browserHistory)
